import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Se quitó i18next-http-backend a propósito.
//
// Estaba configurado para pedir /locales/{lng}/translation.json por HTTP, pero
// esa carpeta NO EXISTE en el proyecto: cada arranque disparaba una petición
// condenada a dar 404. En el servidor real eso pasaba desapercibido; en el
// kiosko react-i18next SUSPENDE los componentes mientras espera, y cuando esa
// suspensión cae en medio de una actualización síncrona —al restaurar la app
// tras cerrar el cover— React lanza el error #426 y revienta la pantalla.
//
// Los textos del menú vienen del JSON del restaurante, no de aquí, así que
// declarar los recursos vacíos deja exactamente el mismo comportamiento que
// había (la clave como texto) pero sin red y sin suspensión.
//
// Si algún día se agregan traducciones de verdad, deben importarse aquí como
// módulos, NUNCA cargarse por HTTP: el iPad tiene que funcionar sin conexión.

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,

    resources: {
      es: { translation: {} },
      en: { translation: {} },
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      // Sin suspensión: es la causa directa del error #426.
      useSuspense: false,
    },
  });

export default i18n;
